import TransportModeFilter from '../../../../../Shared/TransportModeFilter';
import { TransportMode } from '../../../../../../models/transport-mode.enum';
import { TranslationService } from '../../../../../../services/translation.service';

interface ITravelByFootOrBikeSettings {
  showWalking: boolean;
  showBiking: boolean;
  bikeMaxDistance: number;
  bikeSpeed: number;
}

function TravelByFootOrBike({
  className,
  state,
  isInvalid = false,
  onChange,
}: {
  className?: string;
  state: ITravelByFootOrBikeSettings;
  isInvalid?: boolean;
  onChange: (value: ITravelByFootOrBikeSettings) => void;
}) {
  return (
    <div className={className ?? ''}>
      <TransportModeFilter
        availableTransportModes={[TransportMode.walk, TransportMode.bike]}
        selectedTransportModes={[...(state.showWalking ? [TransportMode.walk] : []), ...(state.showBiking ? [TransportMode.bike] : [])]}
        isInvalid={isInvalid}
        onChange={(selectedTransportModes) => {
          onChange({
            showWalking: selectedTransportModes.includes(TransportMode.walk),
            showBiking: selectedTransportModes.includes(TransportMode.bike),
            bikeMaxDistance: state.bikeMaxDistance,
            bikeSpeed: state.bikeSpeed,
          });
        }}
      />
      {state.showBiking && (
        <div>
          <hr />
          <h4>{TranslationService.get('travelplanner.bikefiltersettings')}</h4>
          <div className="row mb-0 mb-sm-2">
            <label htmlFor="bikeMaxDistance" className="col-sm-3 col-form-label fw-normal mb-0 mb-sm-1">
              {TranslationService.get('travelplanner.maxdistance')}
            </label>
            <div className="col-sm-4">
              <select
                id="bikeMaxDistance"
                className="form-select"
                value={state.bikeMaxDistance}
                onChange={(event) => {
                  onChange({ ...state, bikeMaxDistance: parseInt(event.target.value, 10) });
                }}
              >
                <option value="5000">5 km</option>
                <option value="10000">10 km</option>
                <option value="25000">25 km</option>
              </select>
            </div>
          </div>
          <div className="row mb-0">
            <label htmlFor="bikeSpeed" className="col-sm-3 col-form-label fw-normal">
              {TranslationService.get('travelplanner.speed')}
            </label>
            <div className="col-sm-4">
              <select
                id="bikeSpeed"
                className="form-select"
                value={state.bikeSpeed}
                onChange={(event) => {
                  onChange({ ...state, bikeSpeed: parseInt(event.target.value, 10) });
                }}
              >
                <option value="100">{`${TranslationService.get('travelplanner.slow')} (ca 15 km/h)`}</option>
                <option value="85">{`${TranslationService.get('travelplanner.average')} (ca 20 km/h)`}</option>
                <option value="60">{`${TranslationService.get('travelplanner.fast')} (ca 25 km/h)`}</option>
              </select>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default TravelByFootOrBike;
